// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function MarketplaceSection({ api }) {
  const { openMarketplace, setVendorOpen, t } = api || {};
  return (
<section id="marketplace" className="space-y-4">
                <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
                  {t.marketplace.heading}
                </h2>

                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4">
                  <p className="text-slate-200 text-sm sm:text-base max-w-4xl">
                    {t.marketplace.body}
                  </p>

                  <div className="flex flex-wrap gap-3">
                    <button
                      onClick={openMarketplace}
                      className="rounded-2xl border border-sky-500/50 bg-sky-500/10 px-4 py-2 text-sm text-sky-200 hover:border-sky-400"
                    >
                      {t.marketplace.externalCta}
                    </button>

                    <button
                      onClick={() => setVendorOpen(true)}
                      className="rounded-2xl border border-emerald-500/60 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-300 hover:border-emerald-400"
                    >
                      {t.marketplace.vendorCta}
                    </button>
                  </div>

                  <div className="grid gap-3 md:grid-cols-2">
                    <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
                      <div className="text-sm font-semibold text-slate-100">
                        Member Discounts
                      </div>
                      <div className="mt-1 text-xs text-slate-200">
                        {t.marketplace.memberDiscounts}
                      </div>
                    </div>
                    <div className="rounded-2xl border border-slate-800 bg-[#010916]/78 p-4">
                      <div className="text-sm font-semibold text-slate-100">
                        Tax Receipts (where applicable)
                      </div>
                      <div className="mt-1 text-xs text-slate-200">
                        {t.marketplace.taxReceipt}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
  );
}
